import React from "react";
import { countHiddenFromStudents } from "../../schemas/book-schemas";

/**
 * Marks a chapter or lesson that holds blocks students never receive. Without
 * it the only sign is the switch inside each block, so a teacher-only lesson
 * looks identical to a normal one in the outline.
 */
export const StudentHiddenBadge: React.FC<{ section?: any; className?: string }> = ({
  section,
  className = "",
}) => {
  const hidden = countHiddenFromStudents(section);
  if (hidden === 0) {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700 ${className}`}
      title="Học sinh không nhận được các khối này"
      data-testid="student-hidden-badge"
    >
      🙈 {hidden} nội dung ẩn với học sinh
    </span>
  );
};
